import React from "react";
import { TableColumn } from 'react-data-table-component';
import DataGrid from "../../../Component/DataGrid/DataGrid";
import UserDetailsService from "../../../Services/UserDetailsService";
import moment from "moment";
import { UserCardsProps, UserCardsState, IUserCardsDetails } from "./Interface";
import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Popper, Grow, Paper, ClickAwayListener, MenuList, Avatar, Drawer, Grid, Button, Switch } from '@mui/material';
import CustomMaterialMenu from "../../../Component/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu";
import { ShowAlert } from "../../../Component/ShowAlert";
import { Status } from '../../../Component/Reusables/Utility';

class UserCards extends React.Component<UserCardsProps, UserCardsState> {
    private tableColumns: TableColumn<IUserCardsDetails>[] = [
        {
            name: 'User Name',
            selector: row => row.user_name,
            sortable: false,
            id: "UserName"
        },
        {
            name: 'User Email',
            selector: row => row.user_email,
            sortable: false,
            id: "UserEmail"
        },
        {
            name: 'Card Type',
            selector: row => row.card_type,
            sortable: false,
            id: "cardType"
        },
        {
            name: 'Last4',
            selector: row => row.last4,
            sortable: false,
            id: "last4"
        },
        {
            name: 'Brand',
            selector: row => row.brand,
            sortable: false,
            id: "brand"
        },
        {
            name: 'Plaid Account Holder Name',
            selector: row => row.plaid_account_holder_name,
            cell: (row: IUserCardsDetails) => (
                <span
                    style={{
                        color: row.plaid_account_holder_name != row.user_name ? 'red' : 'inherit',
                        fontWeight: row.plaid_account_holder_name != row.user_name ? 'bold' : 'normal'
                    }}
                >
                    {row.plaid_account_holder_name}
                </span>
            ),
            sortable: false,
            id: "plaidAccountHolderName"
        },
        {
            name: 'Plaid Bank Name',
            selector: row => row.plaid_bank_name,
            sortable: false,
            id: "plaidBankName"
        },
        {
            name: 'Bank Name',
            selector: row => row.bank_name,
            sortable: false,
            id: "bankName"
        },
        {
            name: 'Created Date',
            selector: row => moment(row.created_date).format('MM-DD-YYYY hh:mm A'),
            sortable: true,
            id: "CreatedDate"
        },
        {
            name: 'Verification ON/OFF',
            cell: (row) => {
                return (
                    <Switch
                        checked={row.card_status === Status.ACTIVE}
                        onChange={() => this.handleToggleCardStatus(row)}
                        disabled={false}
                        sx={{
                            '& .MuiSwitch-thumb': {
                                backgroundColor: row.card_status === Status.ACTIVE ? "#5aac3d" : "#898989",
                            },
                            '& .MuiSwitch-track': {
                                backgroundColor: row.card_status === Status.ACTIVE ? "#5aac3d" : "#898989",
                            },
                            '& .Mui-checked + .MuiSwitch-track': {
                                backgroundColor: "#5aac3d",
                            },
                            '& .Mui-checked .MuiSwitch-thumb': {
                                backgroundColor: "#5aac3d",
                            }
                        }}
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: '120px'
        }
    ];

    constructor(props: UserCardsProps) {
        super(props);
        this.state = {
            data: [],
            currentPage: 1,
            currentRowsPerPage: 10,
            totalRows: 100,
            searchText: "",
            isCardStatusDialogOpen: false,
            cardId: '',
        }
    }

    public componentDidMount(): void {
        this.getUserCards();
    }

    private getUserCards() {
        let pageIndex: number = (this.state.currentPage - 1);
        let pagination: any = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage,
        };
        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText
        }
        UserDetailsService.getUserCardList(this.props.accessToken, pagination, this.props.userId).then(tr => {
            if (tr.ok) {
                tr.json().then(resp => {
                    this.setState({
                        data: resp.cardList.map((data: any) => ({
                            user_name: data.name,
                            user_email: data.email,
                            card_id: data.cardId,
                            card_type: data.cardType,
                            last4: data.last4,
                            brand: data.brand,
                            plaid_account_holder_name: data.plaidAccountHolderName,
                            plaid_bank_name: data.plaidBankName,
                            bank_name: data.bankName,
                            card_status: (data.isVerificationRequired == "1" ? Status.ACTIVE : Status.INACTIVE),
                            created_date: data.createdUTC
                        })),
                        totalRows: resp.totalPageCount
                    })
                });
            }
        });
    }

    private handleToggleCardStatus = (row: IUserCardsDetails) => {
        let message: string;
        let status: string;
        const updatedStatus = row.card_status === Status.ACTIVE ? Status.INACTIVE : Status.ACTIVE;

        this.setState((prevState) => ({
            data: prevState.data.map(item =>
                item.card_id === row.card_id
                    ? { ...item, card_status: updatedStatus }
                    : item
            )
        }), () => {
            if (updatedStatus === Status.ACTIVE) {
                message = "Card Verification has been enabled";
                status = "success";
            } else {
                message = "Card Verification has been disabled";
                status = "warning";
            }
            const payload = {
                "cardId": row.card_id,
                "isVerificationRequired": updatedStatus === Status.ACTIVE ? 1 : 0
            }
            UserDetailsService.updateCardStatus(this.props.accessToken, payload)
                .then(r => {
                    if (r.ok) {
                        ShowAlert("PassportPay", message, status);
                    }
                })
                .catch(() => {
                    // revert on failure
                    this.setState((prevState) => ({
                        data: prevState.data.map(item =>
                            item.card_id === row.card_id
                                ? { ...item, card_status: row.card_status }
                                : item
                        )
                    }))
                });
        });
    }

    public render() {
        return (
            <>
                <DataGrid
                    gridId="UserCards"
                    columns={this.tableColumns}
                    data={this.state.data}
                    defaultSearch={this.state.searchText}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getUserCards();
                        })
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                        this.setState({
                            currentRowsPerPage: currentRowsPerPage_,
                            currentPage: currentPage_
                        }, () => {
                            this.getUserCards();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getUserCards();
                        })
                    }}
                    pagination
                    exportCsv={this.state.data.length ? true : false}
                    paginationTotalRows={this.state.totalRows}
                />
            </>
        )
    }
}

export default UserCards;